function assignBundleBuilderEvents() {
  var bundle_added_to_shopping_cart = false;
  var bundle_wrapper_elem = document.querySelector('.bb-bundle');
  var bundle_cart_elem = document.querySelector('.bb-bundle .bb-bundle-cart [data-bundle-cart-content]');
  var bundle_buy_button = document.querySelector('.bb-bundle .bb-bundle-cart button[data-action="buy bundle"]');
  var bundle_step_header_elem = document.querySelectorAll('.bb-bundle .bb-step > .bb-step-header');
  var product_elems = document.querySelectorAll('.bb-bundle [data-bundle-product]');
  var product_variant_selector = document.querySelectorAll('.bb-bundle [data-bundle-product] select');
  var product_add_button = document.querySelectorAll('.bb-bundle [data-bundle-product] button');
  var bundle_progress_elems = document.querySelectorAll('.bb-bundle .bb-progress-bar');
  var view_bundle_mobile_button = document.querySelector('.sticky-button-view-bundle-cart');


  /**
    * get a single product from the bundle_options.
    *
    * @param {number} StepID
    * @param {number} ProductID
    */
  function getProduct(StepID, ProductID) {
    let product = null;
    
    if (!StepID || !ProductID) return false;

    // find product
    bundle_options.steps[StepID].products.find(function(p) {
      if (p.id == ProductID) {
        product = p;
      }
    });

    return product;
  } //END getProduct()


  /**
    * get a single product variation from the bundle_options.
    *
    * @param {number} StepID
    * @param {number} ProductID
    * @param {number} VariantID
    */
  function getProductVariation(StepID, ProductID, VariantID) {
    let product_variation = null;
    
    if (!StepID || !ProductID || !VariantID) return false;

    // find product
    bundle_options.steps[StepID].products.find(function(product) {
      if (product.id == ProductID) {

        // find variant
        product.variant.find(function(variant) {
          if (variant.id == VariantID) {
            product_variation = variant;
          }
        });
      }
    });

    return product_variation;
  } //END getProductVariation()


  /**
    * update the product preview in the bundle builder (e.g. show correct variation image, price and quantity)
    *
    * @param {html_elem} Elem
    * @param {number} StepID
    * @param {number} ProductID
    * @param {object} VariantID
    */
  function updateProductPreview(Elem, StepID, ProductID, VariantID) {
    let variation = getProductVariation(StepID, ProductID, VariantID);

    Elem.setAttribute('data-bundle-variation', variation.id);
    Elem.setAttribute('data-quantity', 0);
    Elem.querySelector('img').src = variation.image_url;
    Elem.querySelector('[data-price]').innerHTML = variation.price_with_currency
    Elem.querySelector('.product-quantity').innerHTML = 0;
    Elem.querySelector('.btn-quantity-decrease').setAttribute("disabled", "disabled");
    Elem.querySelector('.btn-quantity-increase').removeAttribute("disabled");

    // get currently selected quantity from cart
    for (let i = 0; i < bundle_cart.steps[parseInt(StepID)].length; i++) {
      let existingItem = bundle_cart.steps[parseInt(StepID)][i];

      if (existingItem.variant_id === variation.id) {
        Elem.setAttribute('data-quantity', existingItem.quantity);
        Elem.querySelector('.product-quantity').innerHTML = existingItem.quantity;

        if (existingItem.quantity > 0) {
          Elem.querySelector('.btn-quantity-decrease').removeAttribute("disabled");
        }

        break;
      }
    }      
  } //END updateProductPreview()


  /**
    * add or remove a product from the bundle cart, also update bundle builder ui
    *
    * @param {number} step_id
    * @param {number} product_id
    * @param {number} variant_id
    * @param {bool} is_incremental
    */
  function addProductToBundleCart(step_id, product_id, variant_id, is_incremental) {
    let product_elem = document.querySelector('[data-bundle-step="' + step_id + '"] [data-bundle-product="' + product_id + '"]');
    let quantity_preview_elem = product_elem.querySelector('.product-quantity');
    let increase_btns = document.querySelectorAll('.bb-steps [data-bundle-step="' + step_id + '"] .btn-quantity-increase');
    let decrease_btn = product_elem.querySelector('.btn-quantity-decrease');
    let min_items = bundle_options.steps[step_id].min;
    let max_items = bundle_options.steps[step_id].max;
    let cartItemExists = false;
    let current_step_quantity = 0;

    for (let i = 0; i < bundle_cart.steps[parseInt(step_id)].length; i++) {
      current_step_quantity += bundle_cart.steps[parseInt(step_id)][i].quantity
    }

    if (current_step_quantity >= max_items && is_incremental === true) {
      return false; // STOP - max quantity reached
    }

    // Check if the item with the specified variant_id already exists in the cart
    for (let i = 0; i < bundle_cart.steps[parseInt(step_id)].length; i++) {
      let existingItem = bundle_cart.steps[parseInt(step_id)][i];

      if (existingItem.variant_id === variant_id) {

        if (is_incremental === false) {
          existingItem.quantity--;
          current_step_quantity--;
        } else {
          existingItem.quantity++;
          current_step_quantity++;
        }

        if (existingItem.quantity <= 0) { // Remove the item from the array
          bundle_cart.steps[parseInt(step_id)].splice(i, 1);
          decrease_btn.setAttribute("disabled", "disabled");
        }
        
        cartItemExists = true;
        break;
      }
    }

    if (!cartItemExists && is_incremental === true) { // add new item
      let product = getProduct(step_id, product_id);
      let product_variation = getProductVariation(step_id, product_id, variant_id);

      let new_cart_item = {
        "id": product.id,
        "variant_id": product_variation.id,
        "name": product.name + ' (' + product_variation.title + ')',
        "image_url": product_variation.image_url,
        "quantity": 1,
        "price": product_variation.price, /* single unit price */
        "price_with_currency": product_variation.price_with_currency
      }
      bundle_cart.steps[parseInt(step_id)].push(new_cart_item);
      decrease_btn.removeAttribute("disabled"); 

      current_step_quantity++;
    }

    quantity_preview_elem.innerHTML = 0;
    product_elem.setAttribute('data-quantity', 0);

    for (let i = 0; i < bundle_cart.steps[parseInt(step_id)].length; i++) {
      let existingItem = bundle_cart.steps[parseInt(step_id)][i];

      // update selected quantity in bundle builder
      if (quantity_preview_elem && existingItem.variant_id === variant_id) {
        quantity_preview_elem.innerHTML = existingItem.quantity;
        product_elem.setAttribute('data-quantity', existingItem.quantity);
        break;
      }
    }

    // update state of increase quantity buttons in current step
    increase_btns.forEach(function(btn) {
      if (current_step_quantity < max_items) {
        btn.removeAttribute("disabled"); 
      } else {
        btn.setAttribute("disabled", "disabled");
      }
    });
  } //END addProductToBundleCart()


  /**
    * check if all min/max conditions for the bundle are met to proceed to checkout, enable/disable final add to cart button
    *
    */
  function validateBundle() {
    let bundle_selection_valid = false;
    let bundle_progress = getBundleProgress();

    if (bundle_options.shop_id === 'sea-to-summit-eu' && bundle_options.mode === 'sleep_system_builder' && bundle_progress.current > 0) {
      bundle_selection_valid = true;
    } else if (bundle_progress.current >= bundle_progress.min) {
      bundle_selection_valid = true;
    } 

    if (bundle_selection_valid === true) {
      bundle_buy_button.removeAttribute('disabled');
      bundle_buy_button.classList.remove("disabled"); 

      // collapse all the bundle steps
      bundle_step_header_elem.forEach(function (elem) {
        elem.setAttribute("aria-expanded", "false");
      });

      // scroll to cart
      // setTimeout(function() {
      //   if (window.innerWidth >= 768) {
      //     bundle_wrapper_elem.scrollIntoView({
      //       behavior: "smooth",
      //       block: "start",
      //     });
      //   } else {
      //     document.querySelector('#BundleCart').scrollIntoView({
      //       behavior: "smooth",
      //       block: "start",
      //     });
      //   }          
      // }, 300);

      return true;    
    } else {
      bundle_buy_button.setAttribute('disabled', 'disabled');
      bundle_buy_button.classList.add('disabled'); 
      return false;
    }
  } //END validateBundle()


  /**
    * visually update the bundle cart, show all products added
    *
    */
  function updateBundleCart() {
    var html = '';
    var product_count = 0;
    var progress = getBundleProgress();

    bundle_cart.cost = 0;
    bundle_cart.final_cost = 0;

    for (let step in bundle_cart.steps) {
      for (let item of bundle_cart.steps[step]) {
        product_count += item.quantity;
      }
    }

    // show success message if bundle was added to Shopify cart
    if (bundle_added_to_shopping_cart === true) {
      html += '<span class="bundle-cart-success">';
      html += '<img src="https://img.icons8.com/fluency-systems-regular/50/222222/ok.png" alt="" width="25" height="25" loading="lazy" style="display: block; width: 25px; margin: 0 auto 0.5rem auto;" />';
      html += bundle_options.namespace + ' added to cart';
      html += '</span>';

      bundle_cart_elem.innerHTML = '<div class="bb-cart-is-empty">' + html + '</div>';
      bundle_added_to_shopping_cart = false;
      return;
    } 
    
    // create bundle item preview
    for (let step in bundle_cart.steps) {
      
      if (bundle_cart.steps[step].length === 0) {
        html += '<div class="item item-placeholder" data-view-step="' + step + '" title="view items">';
        html += '  <span>' + bundle_options.steps[step].label + '</span>';
        html += '</div>';
      }

      // add all the items of a single step
      for (let product of bundle_cart.steps[step]) {
        html += '<div class="item">';
        html += '  <img src="' + product.image_url + '" width="180" height="180" loading="lazy" alt="' + product.name + '" />';
        html += '  <div class="item-description">';
        html += '    <p class="item-name">' + product.name + '</p>';
        html += '    <p>' + product.quantity + '&times; ' + product.price_with_currency + '</p>';
        html += '  </div>';
        html += '  <span class="btn-remove-item" data-step="' + step + '" data-product="' + product.id + '" data-variant="' + product.variant_id  + '" title="remove item"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"><title>remove item</title><path d="M4.667 14c-.3667 0-.6804-.1304-.9413-.3913-.261-.2609-.3916-.5749-.392-.942V4H2.667V2.6667h3.3333V2h4v.6667h3.3334V4h-.6667v8.6667c0 .3666-.1305.6806-.3913.942-.2609.2613-.5749.3917-.942.3913H4.667Zm6.6667-10H4.667v8.6667h6.6667V4Zm-5.3334 7.3333h1.3334v-6H6.0003v6Zm2.6667 0h1.3333v-6H8.667v6Z"/></svg></span>';
        html += '</div>';

        // add item cost
        bundle_cart.cost += product.quantity * product.price;
      }       
    }

    bundle_cart.final_cost = bundle_cart.cost * bundle_options.discount_mod;
   
    if (progress.progress === 1) {
      // bundle 100% complete
      html += '<p class="cost">';
      if (bundle_options.discount_mod != 1 && bundle_options.discount_preview != '') {
        html += '  <span class="price-strikethrough">' + formatToPrice(bundle_cart.cost, true) + '</span><br />';
      }
      html += '  <span class="price-label">Total</span>';
      html += '  <span class="price-normal">' + formatToPrice(bundle_cart.final_cost, true) + '</span>';
      html += '</p>';
    } else if (progress.current >= progress.min) {
      // bundle partly complete
      html += '<p class="cost">';
      html += '  <span class="price-label">Total</span>';
      html += '  <span class="price-normal">' + formatToPrice(bundle_cart.cost, true) + '</span>';
      html += '</p>';
    } else {
      // bundle not complete
      html += '<p class="cost">';
      html += '  <span class="price-label">&nbsp;</span>';
      if (bundle_options.discount_mod != 1 && bundle_options.discount_preview != '') {
        html += '  <span class="price-normal">add ' + (progress.min > 0 ? progress.min : '') + ' items to save ' + bundle_options.discount_preview + '</span>';
      } else {
        html += '  <span class="price-normal">add ' + (progress.min > 0 ? progress.min : '') + ' items</span>';
      }
      html += '</p>';
    }

    bundle_cart_elem.innerHTML = html;
  } //END updateBundleCart()


  /**
    * visually update the bundle steps (show tick), auto proceed to next step
    *
    * @param {integer} Step
    */
  function updateBundleStep(Step) {
    let product_count = 0;

    for (let item of bundle_cart.steps[Step]) {
      product_count += item.quantity;
    }

    // if min step quantity reached
    if (product_count >= bundle_options.steps[Step].min) {
      bundle_step_header_elem[Step].setAttribute('data-status', 'done')
    } else {
      bundle_step_header_elem[Step].setAttribute('data-status', 'pending')
    }

    // if sleep system builder, go to next step if one or more iteams are chosen for the current step
    if (bundle_options.mode === 'sleep_system_builder' && product_count > 0) {
      setTimeout(function() {
        goToBundleStep(parseInt(Step) + 1);
      }, 1000);

      return;
    }

    // if max step quantity is reached and bundle is incomplete go to next step
    if (Step != bundle_options.steps.length - 1 && product_count === bundle_options.steps[Step].max && !validateBundle()) {
      setTimeout(function() {
        goToBundleStep(parseInt(Step) + 1);
      }, 1000);
    }
  } //END updateBundleStep()


  /**
    * change product preview in bundle when variation select field changes
    *
    * @param {event} event
    */
  function onVariationChange(e) {
    let product_elem = e.target.closest('[data-bundle-product]');
    
    if (!product_elem) return false;

    let step_id = product_elem.getAttribute('data-bundle-step');
    let product_id = product_elem.getAttribute('data-bundle-product');
    let variant_id = e.target.value;

    updateProductPreview(product_elem, step_id, product_id, variant_id);
  } //END onVariationChange()


  /**
    * add or remove a product from the bundle
    *
    * @param {event} event
    * @param {bool} 1 increase, 0 decrease
    */
  function onAddToBundle(e, is_incremental) {
    let product_elem = e.target.closest('[data-bundle-product]')
    let step_id = product_elem.getAttribute('data-bundle-step');
    let product_id = product_elem.getAttribute('data-bundle-product');
    let variant_id = product_elem.querySelector('select').value;
    let product_obj = getProduct(step_id, product_id);

    if (typeof is_incremental !== 'boolean') is_incremental = true; /* true = quantity++, false = quantity-- */

    addProductToBundleCart(step_id, product_id, variant_id, is_incremental);
    updateBundleCart();
    updateBundleStep(step_id);
    updateBundleProgressBar();
    validateBundle();

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'event': 'bundle_action',
      'description': (is_incremental ? 'add_item_to_bundle' : 'remove_item_from_bundle'),
      'product_id': product_id,
      'variant_id': variant_id,
      'step': (parseInt(step_id) + 1),
      'product_name': product_obj.name,
      'bundle_name': bundle_options.name
    });
    
    return false;
  } //END onAddToBundle()


  /**
    * delete a product from the bundle cart (set quantity to 0) and update bundle builder UI
    *
    * @param {number} step_id
    * @param {number} product_id
    * @param {number} variant_id
    */
  function removeItemFromCart(step_id, product_id, variant_id) {
  
    for (let i = 0; i < bundle_cart.steps[parseInt(step_id)].length; i++) {
      let product = bundle_cart.steps[parseInt(step_id)][i];

      if (product.id == product_id && product.variant_id == variant_id) {
        let product_elem = document.querySelector('[data-bundle-step="' + step_id + '"] [data-bundle-product="' + product_id + '"][data-bundle-variation="' + variant_id + '"]');

        // delete from cart
        bundle_cart.steps[parseInt(step_id)].splice(i, 1);

        // enable increase quantity buttons for all items in that step
        document.querySelectorAll('[data-bundle-step="' + step_id + '"] .btn-quantity-increase').forEach(function(elem) {
          elem.removeAttribute("disabled"); 
          elem.classList.remove("disabled"); 
        });

        // reset product
        if (product_elem) {
          product_elem.querySelector('.btn-quantity-decrease').setAttribute("disabled", "disabled");
          product_elem.querySelector('.product-quantity').innerHTML = 0;
          product_elem.setAttribute('data-quantity', 0);
        }

        let product_obj = getProduct(step_id, product_id);

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          'event': 'bundle_action',
          'description': 'remove_item_from_bundle',
          'product_id': product_id,
          'variant_id': variant_id,
          'step': (parseInt(step_id) + 1),
          'product_name': product_obj.name,
          'bundle_name': bundle_options.name
        });
            
        break;
      }
    }
    
    updateBundleStep(step_id);
    updateBundleCart();
    updateBundleProgressBar();
    validateBundle();
    goToBundleStep(parseInt(step_id), true);
  } //END removeItemFromCart()


  /**
    * return bundle progress as object (progress = 0 ... 1)
    *
    */
  function getBundleProgress() {
    var progress = {
      current: 0,
      min: 0,
      max: 0,
      progress: 0
    };

    for (let i=0; i < bundle_options.steps.length; i++) {
      let step_current = 0;

      for (let j=0; j < bundle_cart.steps[i].length; j++) {
        step_current += bundle_cart.steps[i][j].quantity;
      }

      progress.current += step_current;      
      progress.min += bundle_options.steps[i].min;
      progress.max += bundle_options.steps[i].max;
    }

    // avoid that that the minimum number of products is smaller than the number of steps
    if (progress.min < bundle_options.steps.length) {
      progress.min = bundle_options.steps.length
    }

    // calculate progress (min 0, max 1)
    progress.progress = Math.round(progress.current / progress.min * 1000) / 1000;
    progress.progress = Math.min(1, Math.max(0, progress.progress));
    
    return progress;
  } //END getBundleProgress()


  /**
    * visualize the bundle completion progress (full progress bar = minimum number of items in each step added)
    *
    */
  function updateBundleProgressBar() {
    let progress = getBundleProgress();

    bundle_progress_elems.forEach(elem => {
      elem.dataset.progress = progress.progress; // Set data attribute 'data-progress'
      elem.style.setProperty('--progress', progress.progress); // Set CSS custom property '--progress'
    });
  } //END updateBundleProgressBar()


  // /**
  //   * move the progress bar on window resize
  //   *
  //   * @param {element} elem new parent node
  //   */
  // function onResizeMoveBundleProgressBar() {
  //   bundle_progress_elem.parentNode.removeChild(bundle_progress_elem);

  //   if (window.innerWidth < 768) {
  //     view_bundle_mobile_button.prepend(bundle_progress_elem);
  //   } else {
  //     bundle_wrapper_elem.prepend(bundle_progress_elem);
  //   }
  // } //END onResizeMoveBundleProgressBar()
  

  /**
    * submit bundle items to shopify cart
    *
    * @param {event} event
    */
  function onBuyBundle(e) {
    e.preventDefault();

    if (!validateBundle()) {
      console.log('Error: The bundle is invalid. Check your product quantity');
      return false;
    }

    let payload = {
      "items": []
    };

    for (let step in bundle_cart.steps) {
      for (let product of bundle_cart.steps[step]) {
        payload.items.push({
          "id": product.variant_id,
          "quantity": product.quantity,
        });
      }
    }

    if (payload.items.length == 0) return false;

    // add bundle items to ajax cart
    liquidAjaxCart.cartRequestAdd(payload);

    bundle_added_to_shopping_cart = true;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'event': 'bundle_action',
      'description': 'add_bundle_to_cart',
      'bundle_name': bundle_options.name
    });

    resetBundle();
  } //END onBuyBundle()


  /**
    * convert cents to dollars and format as currency, append "$" symbol, force two decimal places
    *
    * @param {int} priceInCents
    */
  function formatToPrice(priceInCents, forceDecimals) {
    const currencyFormats = {
      USD: { symbol: '$',  decimal: '.', thousand: ',', prepend: true },
      CAD: { symbol: '$',  decimal: '.', thousand: ',', prepend: true },
      MXN: { symbol: '$',  decimal: '.', thousand: ',', prepend: true },
      AUD: { symbol: '$',  decimal: '.', thousand: ',', prepend: true },
      NZD: { symbol: '$',  decimal: '.', thousand: ',', prepend: true },
      EUR: { symbol: '€',  decimal: ',', thousand: '.', prepend: true },
      GBP: { symbol: '£',  decimal: '.', thousand: ',', prepend: true },
      NOK: { symbol: 'kr', decimal: ',', thousand: '.', prepend: false },
      SEK: { symbol: 'kr', decimal: ',', thousand: '.', prepend: false },
      DKK: { symbol: 'kr', decimal: ',', thousand: '.', prepend: false }
    };

    const current_store_currency = Shopify.currency.active; // AUD, USD, EUR, NOK, ...
    const currency = currencyFormats[ current_store_currency ];
    if (!currency) {
      return 'currency not supported';
    }
    
    let price = priceInCents / 100;
    let parts = price.toFixed(2).split('.');
    let integerPart = parts[0];
    let decimalPart = parts[1] || '';

    // Format the integer part with thousand separators
    integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, currency.thousand);

    // Decide whether to force decimals
    if (forceDecimals || decimalPart.length > 0) {

      if (currency.prepend) {
        return `${currency.symbol}${integerPart}${currency.decimal}${decimalPart}`; // €19.00
      } else {
        return `${integerPart}${currency.decimal}${decimalPart} ${currency.symbol}`;// 19.00 kr
      }
    } else {
      if (currency.prepend) {
        return `${currency.symbol}${integerPart}`; // $19
      } else {
        return `${integerPart} ${currency.symbol}`; // 19 kr
      }
    }
  } //END formatToPrice()


  /**
    * show/hide logic to show sticky show bundle cart button (mobile only)
    *
    */
  function setupViewCartButtonIntersectionObserver() {
    const bundleCartElem = document.querySelector("#BundleCart");
    if (!bundleCartElem) return;
    
    const handleIntersection = (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && view_bundle_mobile_button) {
          view_bundle_mobile_button.classList.remove('active');
        } else {
          view_bundle_mobile_button.classList.add('active');
        }
      });
    };
  
    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 0.5,
    };
  
    const observer = new IntersectionObserver(handleIntersection, options);
    observer.observe(bundleCartElem);
  } //END setupViewCartButtonIntersectionObserver()
  

  /**
    * reset everything
    *
    */
  function resetBundle() {

    // clear cart
    for (let i=0; i < bundle_options.steps.length; i++) {
      bundle_cart.steps[i] = [];
      bundle_step_header_elem[i].setAttribute('data-status', 'pending')
    }

    // reset product quantities
    product_elems.forEach(function(item) {
      let item_quantity_selector = item.querySelector('.product-quantity');
      item.setAttribute('data-quantity', 0);
      if (item_quantity_selector) {
        item_quantity_selector.innerHTML = 0;
        item.querySelector('.btn-quantity-decrease').setAttribute("disabled", "disabled");
        item.querySelector('.btn-quantity-increase').removeAttribute("disabled");
      }
    })

    // reset UI
    updateBundleCart();
    goToBundleStep(0, true);
    updateBundleProgressBar();
    validateBundle();

    bundle_buy_button.setAttribute("disabled", "disabled");
    bundle_buy_button.classList.add("disabled"); 
  } //END resetBundle()


  /**
    * open a specific bundle step
    *
    * @param {integer} i
    * @param {bool} avoidToggle
    */
  function goToBundleStep(i, avoidToggle) {
    let elem = bundle_step_header_elem[i];
    if (!elem) return false;

    if (elem.getAttribute("aria-expanded") == "true" && avoidToggle !== true) {
      elem.setAttribute("aria-expanded", "false");
    } else {

      // hide all the other ones
      bundle_step_header_elem.forEach(function (other_elem, j) {
        if (j !== i) {
          if (other_elem.getAttribute("aria-expanded") == "true" && j <= i) { // avoid awkward scroll jumps
            other_elem.scrollIntoView({
              behavior: "instant",
              block: "start"
            });
          }

          other_elem.setAttribute("aria-expanded", "false");
        }
      });

      elem.setAttribute("aria-expanded", "true");

      setTimeout(function() {
        
        elem.scrollIntoView({
          behavior: "smooth",
          block: "start"
        });
      }, 300);
    }
  } //END goToBundleStep()


  /**
    * create and insert the HTML for the filter UI
    * read 'bundle_filters' object and create html
    */
  function buildBundleBuilderFilterUI() {
    const filter_wrappers = document.querySelectorAll('.bb-bundle-filter');
    let filter_html = '';

    if (!filter_wrappers || !bundle_filters) return false;

    // Loop through the bundle_filters object
    for (const key in bundle_filters) {
      if (Object.hasOwnProperty.call(bundle_filters, key)) {
        const filter = bundle_filters[key];

        filter_html += '<div class="bb-filter" data-filter="' + key + '">';
        if (!filter.tooltip) {
          filter_html += '  <p class="bb-filter-name">' + filter.name + '</p>';
        } else {
          filter_html += '<p class="bb-filter-name">';
          filter_html += '  ' + filter.name;
          filter_html += '  <span class="bb-filter-tooltip-toggle">';
          filter_html += '    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 20 20" fill="currentColor"><title>info</title><path d="M9.95 16c.35 0 .65-.12.89-.36.24-.25.36-.54.36-.89s-.12-.65-.36-.89a1.2 1.2 0 0 0-.89-.36c-.35 0-.65.12-.89.36s-.36.54-.36.89.12.65.36.89c.25.24.54.36.89.36Zm-.9-3.85h1.85c0-.55.06-.98.19-1.3.12-.32.48-.75 1.06-1.3.43-.43.78-.85 1.03-1.24s.37-.86.37-1.41a2.5 2.5 0 0 0-1.03-2.15A4 4 0 0 0 10.1 4c-.95 0-1.72.25-2.31.75-.6.5-1 1.1-1.24 1.8l1.65.65c.08-.3.27-.62.56-.97.3-.35.74-.53 1.34-.53.53 0 .93.15 1.2.44.27.29.4.61.4.96 0 .33-.1.65-.3.94a4 4 0 0 1-.75.81 6.22 6.22 0 0 0-1.35 1.47c-.17.34-.25.95-.25 1.83ZM10 20a10.08 10.08 0 0 1-9.21-6.1A9.75 9.75 0 0 1 0 10a10.15 10.15 0 0 1 2.92-7.07 10.04 10.04 0 0 1 14.15 0A10.1 10.1 0 0 1 20 10a10 10 0 0 1-10 10Z"/></svg>';
          filter_html += '  </span>';
          filter_html += '</p>';
        } 
        if (filter.description) {
          filter_html += '  <p class="bb-filter-description">' + filter.description + '</p>';
        }
        if (filter.tooltip) {
          filter_html += '  <div class="bb-filter-tooltip">';
          filter_html += '    <h5 style="text-transform: none;">' + filter.name + '</h5>';
          filter_html += '    ' + filter.tooltip;
          filter_html += '  </div>';
        }
        filter_html += '  <div class="bb-filter-options">';
        filter_html += '    <div class="range" style="--range-steps: ' + filter.steps.length + '">';
        filter_html += '      <span class="range-track"></span>';
        filter_html += '      <span class="range-thumb"></span>';
        filter_html += '      <span class="range-labels">';
        filter.steps.forEach(step => {
          filter_html += '      <span data-range-label="' + step.label + '" data-tag="' + step.tag + '"></span>';
        });
        filter_html += '      </span>';
        filter_html += '    </div>';
        filter_html += '  </div>';
        filter_html += '</div>';
      }
    }

    filter_wrappers.forEach(elem => {
      elem.innerHTML = filter_html;
    });
  } //END buildBundleBuilderFilterUI()


  /**
   * assign event listeners to select a filter and then assign it
   * 
   */
  function assignBundleBuilderFilterEvents() {
    const filter_elems = document.querySelectorAll('.bb-filter[data-filter]');
    if (!filter_elems || !bundle_filters) return false;

    filter_elems.forEach(filter => {
      let filterKey = filter.getAttribute("data-filter");
      let rangeElem = filter.querySelector('.range');
      let rangeThumb = filter.querySelector('.range-thumb');
      let rangeLabels = filter.querySelectorAll('.range-labels > span');
      let rangeSteps = rangeLabels.length;
      let currentStep = 0;

      function handleMouseAndTouchMove(event) {
        var clientX = 0 

        // get position of moved cursor or touch position
        if (event.type === "mousemove") {
          var clientX =  event.clientX;
        } else if (event.type === "touchmove") {
          var clientX =  event.touches[0].clientX;
        } else {
          return;
        }

        const rangeWidth = filter.querySelector('.range').offsetWidth;
        const rangeXpos = rangeElem.getBoundingClientRect().x;
        const thumbWidth = rangeThumb.offsetWidth;
        const mouseX =  clientX - rangeXpos - thumbWidth / 2;
        const maxX = rangeWidth - thumbWidth;
        const stepSize = maxX / (rangeSteps - 1);
        let position = Math.min(Math.max(mouseX, 0), maxX);
      
        // snap to the nearest step
        position = Math.round(position / stepSize) * stepSize;
           
        // calculate the step based on the thumb snapped position
        let calculatedStep = Math.round((position / maxX) * (rangeSteps - 1) + 1);

        if (currentStep != calculatedStep) {
          updateActiveStep(calculatedStep);
        }
      }
      
      function handleMouseUp() {
        document.removeEventListener('mousemove', handleMouseAndTouchMove);
        document.removeEventListener('mouseup', handleMouseUp);

        user_filter[filterKey] = {
          'tag':           bundle_filters[filterKey].steps[parseInt(currentStep - 1)].tag,
          'collection_id': bundle_filters[filterKey].collection_id
        };

        // apply the filters
        assignFiltersToProductCards();
      }

      function handleTouchEnd() {
        document.removeEventListener('touchmove', handleMouseAndTouchMove);
        document.removeEventListener('touchend', handleTouchEnd);

        user_filter[filterKey] = {
          'tag':           bundle_filters[filterKey].steps[parseInt(currentStep - 1)].tag,
          'collection_id': bundle_filters[filterKey].collection_id
        };

        // apply the filters
        assignFiltersToProductCards();
      }
      
      function updateActiveStep(step) {
        currentStep = step;
        
        rangeElem.style.setProperty('--current-step', currentStep);
      
        rangeLabels.forEach(label => {
          label.classList.remove('active');
        });
        
        if (rangeLabels[step - 1]) {
          rangeLabels[step - 1].classList.add('active');
        }
        
        // debug
        // console.log( 'debug', currentStep + ' | label: ' + bundle_filters[filterKey].steps[parseInt(step - 1)].label + ' | value: ' + bundle_filters[filterKey].steps[parseInt(step - 1)].tag );
      }
      
      rangeThumb.addEventListener('mousedown', handleMouseDown);

      function handleMouseDown(event) {
        event.preventDefault();
        document.addEventListener('mousemove', handleMouseAndTouchMove);
        document.addEventListener('mouseup', handleMouseUp);
      }

      rangeThumb.addEventListener('touchstart', handleTouchStart);

      function handleTouchStart(event) {
        event.preventDefault();
        document.addEventListener('touchmove', handleMouseAndTouchMove);
        document.addEventListener('touchend', handleTouchEnd);
      }

      rangeLabels.forEach(function(rangeLabel, i) {
        rangeLabel.addEventListener('click', function() {

          user_filter[filterKey] = {
            'tag': rangeLabel.getAttribute('data-tag'),
            'collection_id': bundle_filters[filterKey].collection_id
          };

          updateActiveStep(i + 1);
          assignFiltersToProductCards();
        });
      })
    }); // filter_elems

    function resetFilters() {
      Object.entries(user_filter).forEach(([key, index]) => {
        user_filter[key].tag = '';
      });
      
      updateBundleFilterUI();
      assignFiltersToProductCards();
    } //END resetFilters()

    let reset_filters_button = document.querySelectorAll('button.button-reset-all-filter');

    reset_filters_button.forEach(button => {
      button.addEventListener('click', resetFilters);
    });

    let filter_tooltip_toggle_elems = document.querySelectorAll('.bb-bundle-filter .bb-filter-tooltip-toggle');

    filter_tooltip_toggle_elems.forEach(elem => {
      elem.addEventListener('click', function() {
        elem.closest('.bb-filter').classList.toggle('show-tooltip');
      });
    });
  } //END assignBundleBuilderFilterEvents()


  /**
   * show/hide the filter UI on mobile
   * (it is hidden by default on mobile)
   */
  function toggleFilterUIvisibility() {
    const filter_ui_mobile_elem = document.querySelector('.bb-bundle-filter-wrapper.filter-mobile');
    
    filter_ui_mobile_elem.classList.toggle('show');

    if (filter_ui_mobile_elem.classList.contains('show')) { 
      filter_ui_mobile_elem.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }    
  } //END toggleFilterUIvisibility()


  /**
   * only show products that match the selected filters
   * (some filters are limited to specific collection)
   * 
   */
  function assignFiltersToProductCards() {
    var product_ids = []; // all products we display

    // loop trough all the bundle steps and determine if active filter tags relate to step
    for (var i=0; i<bundle_options.steps.length; i++) {
      let filter_tags = [];

      Object.keys(user_filter).forEach(function(key, index) {

        if (user_filter[key].tag) {
          if ( user_filter[key].collection_id.length == 0) {
            // filter tag is not limited to any collections -> add it
            filter_tags.push( user_filter[key].tag );
          } else if ( user_filter[key].collection_id.includes( bundle_options.steps[i].collection_id )) {
            // filter tag is limited to the current collection -> add it
            filter_tags.push( user_filter[key].tag );
          }
        }
      });

      for (var j=0; j<bundle_options.steps[i].products.length; j++) {
        let item = bundle_options.steps[i].products[j];

        // add product if all filter tags are included in the product, also add product if NO filter tags are available
        if (filter_tags.length === 0 || filter_tags.every(tag_name => item.tags.includes(tag_name))) {
          product_ids.push( parseInt(item.id) );
        }
      }
    }
  
    // for each bundle step, show the product cards that qualify
    var bundle_steps = document.querySelectorAll('.bb-steps > .bb-step');
    bundle_steps.forEach(function(bundle_step) {
      var summary_card_elem = bundle_step.querySelector('.bb-product-card.bb-filter-summary');       
      var product_card_elems = bundle_step.querySelectorAll('.bb-product-card[data-bundle-product]');
      var all_items = product_card_elems.length;
      var matching_items = 0;

      // loop through all the cards and update their visibility
      product_card_elems.forEach(function(product_card) {
        var product_id = parseInt(product_card.getAttribute("data-bundle-product"));

        if (product_ids.includes(product_id)) {
          product_card.classList.add('active');
          matching_items++;
        } else {
          product_card.classList.remove('active');
        }
      });

      // now update the summary card content and visiblity
      let summary_card_message = matching_items + ' / ' + all_items + ' items match&nbsp;your filter&nbsp;preference';

      if (matching_items ==  0) {
        summary_card_message = 'No items match your filter&nbsp;preference.<br />';
        summary_card_message += '<strong style="display: block; font-weight: inherit; margin-top: 0.5rem;">⚠ Please adjust your filters.</strong>';
        summary_card_elem.classList.add('is-no-results');
      } else {
        summary_card_elem.classList.remove('is-no-results');
      }

      summary_card_elem.querySelector('p').innerHTML = summary_card_message;
       
      if (matching_items == all_items) {
        summary_card_elem.classList.remove('active');
      } else {
        summary_card_elem.classList.add('active');
      } 
    });

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'event': 'bundle_action',
      'description': 'assign_bundle_filters',
      'bundle_name': bundle_options.name
    });
  } //END assignFiltersToProductCards()

  
  /**
   * pull in the filters set in user_filter and update the UI to that state (e.g. reset bundle)
   *  
   */
  function updateBundleFilterUI() {
    if (!user_filter) return false;
    
    // loop trough all filters and set the filter position to whatever is in user_filter
    Object.entries(user_filter).forEach(([key, index]) => {

      var filter_elems = document.querySelectorAll('.bb-filter[data-filter="' + key + '"]');
      filter_elems.forEach(function(filter_elem) {
        var filter_options_parent = filter_elem.querySelector('.range-labels');
        var filter_options = filter_elem.querySelectorAll('.range-labels > [data-range-label]');

        filter_options.forEach(function(option_elem) {
          option_elem.classList.remove('active');

          if (option_elem.getAttribute('data-tag') == user_filter[key].tag) {
            option_elem.classList.add('active');
            let index = Array.from(filter_options_parent.children).indexOf(option_elem) + 1;
            filter_elem.querySelector('.range').style.setProperty('--current-step', index);
          } 
        })
      });
    });
  } //END updateBundleFilterUI()


  /**
    * assign all click events and set initial state
    *
    */
  function init() {
  
    // save the accesstoken
    var accessTokenMetaTag = document.querySelector('meta[name="shopify-checkout-api-token"]');
    bundle_options.accesstoken = accessTokenMetaTag ? accessTokenMetaTag.getAttribute('content') : null;

    if (bundle_options.mode === 'sleep_system_builder') {
      buildBundleBuilderFilterUI();
      assignBundleBuilderFilterEvents();
    }

    updateBundleCart();

    setupViewCartButtonIntersectionObserver();

    // assign select events
    product_variant_selector.forEach(function(elem) {
      elem.addEventListener("change", onVariationChange);
    });

    // assign button click events
    product_add_button.forEach(function(elem) {
      elem.addEventListener("click", onAddToBundle);
    });

    // assign buy bundle click event
    bundle_buy_button.addEventListener("click", onBuyBundle);

    // assign more click events
    document.addEventListener("click", function(event) {
      const elem = event.target;

      // increase quantity (++)
      if (elem.classList.contains("btn-quantity-increase")) { 
        onAddToBundle(event, true);
        return;
      } 

      // decrease quantity (--)
      if (elem.classList.contains("btn-quantity-decrease")) { 
        onAddToBundle(event, false);
        return
      } 

      // remove specific item from cart
      if (elem.classList.contains("btn-remove-item")) {
        let step = parseInt(elem.getAttribute("data-step"));
        let product_id = parseInt(elem.getAttribute("data-product"));
        let variant_id = parseInt(elem.getAttribute("data-variant"));

        removeItemFromCart(step, product_id, variant_id)
        return;
      }

      // show step n
      if (elem.hasAttribute("data-view-step")) {
        goToBundleStep( parseInt(elem.getAttribute("data-view-step")), true )
        return;
      }

      // show/hide click event for filter UI visibility (hidden on mobile, but not desktop)
      if (elem.classList.contains("btn-toggle-filter-visibility")) {
        toggleFilterUIvisibility();
      }
    });

    // assign accordion open/close events and hide all except the first by default
    bundle_step_header_elem.forEach(function(elem, i) {
      elem.addEventListener("click", function() {
        goToBundleStep(i);
      });

      if (i !== 0) {
        elem.setAttribute("aria-expanded", "false");
      }
    });
    
    // disable bundle buy button
    bundle_buy_button.setAttribute("disabled", "disabled");
    bundle_buy_button.classList.add("disabled"); 
  } //END init()

  init();
} //END assignBundleBuilderEvents()


document.addEventListener("DOMContentLoaded", function(event) {
  assignBundleBuilderEvents();
});